import { bbox, FeatureCollection } from '@turf/turf'

export const parcelSearchFeatureBoundingBox = (fc: FeatureCollection) => {
  let minLat, minLng, maxLat, maxLng
  if (fc.features[0].properties?.boundingBox) {
    const boundingBox = JSON.parse(fc.features[0].properties?.boundingBox)
    minLng = boundingBox[0][0]
    minLat = boundingBox[0][1]
    maxLng = boundingBox[1][0]
    maxLat = boundingBox[1][1]
  } else {
    const bounds = bbox(fc)
    minLng = bounds[0]
    minLat = bounds[1]
    maxLng = bounds[2]
    maxLat = bounds[3]
  }

  return [minLng, minLat, maxLng, maxLat]
}
